export default __webpack_public_path__ + "static/media/chain-icon.8895897b.webp";